import { render, staticRenderFns } from "./PrescriptionPurchase.vue?vue&type=template&id=81c10802&scoped=true&lang=pug"
import script from "./PrescriptionPurchase.vue?vue&type=script&lang=js"
export * from "./PrescriptionPurchase.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionPurchase.vue?vue&type=style&index=0&id=81c10802&prod&lang=scss&scoped=true"
import style1 from "./PrescriptionPurchase.vue?vue&type=style&index=1&id=81c10802&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c10802",
  null
  
)

export default component.exports